interface Props {
  cast: any[];
}

export default function CastList({ cast }: Props) {
  if (!cast.length) return null;
  return (
    <section className="py-8 md:py-10 border-t border-background-200/70">
      <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-5 flex items-center gap-2">
        <i className="ri-team-line text-primary-500"></i>
        演员表
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {cast.map((actor: any) => (
          <div
            key={actor.id}
            className="flex items-center gap-3 p-3 rounded-lg bg-background-100 border border-background-200/60"
          >
            <div className="w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-full overflow-hidden bg-background-200">
              <img
                src={actor.avatar}
                alt={`演员 ${actor.name}`}
                title={`${actor.name} 演员资料`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="min-w-0">
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 truncate">
                {actor.name}
              </h3>
              <p className="mt-0.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{actor.bio}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}